// Monitoring UI state shared across the Monitoring / Alerts / Imagery tabs:
// the map-selected area and the alert feed signal coming in over WS.
export default {
  namespaced: true,
  state: () => ({
    // { projectId: string, code, name } — null means "all areas"
    selectedArea: null,
    unreadAlerts: 0,
    // Bumped on every incoming WS alert so pages can react without an event bus.
    alertTick: 0,
    lastAlert: null,
  }),
  mutations: {
    SET_SELECTED_AREA(state, { projectId, code, name }) {
      state.selectedArea = { projectId: String(projectId), code, name }
    },
    CLEAR_SELECTED_AREA(state) {
      state.selectedArea = null
    },
    SET_UNREAD_ALERTS(state, count) {
      state.unreadAlerts = count
    },
    ALERT_RECEIVED(state, alert) {
      state.lastAlert = alert
      state.alertTick += 1
      state.unreadAlerts += 1
    },
  },
  getters: {
    selectedArea: (state) => state.selectedArea,
    unreadAlerts: (state) => state.unreadAlerts,
    alertTick: (state) => state.alertTick,
  },
}
